module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabslider"
  }, [_c('div', {
    staticClass: "tab_header"
  }, [_c('ul', {
    staticClass: "tab"
  }, _vm._l((_vm.tabList), function(item, subindex) {
    return _c('li', {
      key: subindex
    }, [_c('div', {
      staticClass: "body_bottom",
      class: [_vm.tabIndex == subindex ? 'active_color' : ''],
      on: {
        "click": function($event) {
          _vm.jump(subindex, $event)
        }
      }
    }, [_vm._v(_vm._s(item))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('div', {
    class: {
      shift: _vm.isMove
    },
    style: ({
      width: _vm.boxNum * this.windowsW + 'px',
      marginLeft: _vm.marginLeft + 'px'
    }),
    on: {
      "touchstart": function($event) {
        _vm.start($event)
      },
      "touchmove": function($event) {
        _vm.move($event)
      },
      "touchend": function($event) {
        _vm.end($event)
      }
    }
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15c32c98","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/tabslideTamplete.vue
// module id = sGbQ
// module chunks = 6